<template>
    <div class="datepicker-list gap-4 p-0 pl-4 pr-4 bg-white">
        <div v-if="Object.keys(items).length">
            <div class="flex justify-between w-full">
                <div>
                    <span
                        class="list--header flex h-10 flex-col justify-center self-stretch text-text-default font-Open font-bold"
                        >{{ props.title }}</span
                    >
                </div>
            </div>
            <ul :class="{ 'show-limited': !showMore.enabled }">
                <li
                    v-for="(item, key, index) in items"
                    :key="index"
                    class="cursor-pointer"
                    @click="selectItem(key)">
                    <div
                        :class="[
                            {
                                'selected rounded border border-solid border-[#5856d6] font-bold bg-[#f7f7fd] shadow-sm':
                                    currentlySelected === key,
                            },
                            'card border mb-2 p-8 flex flex-col justify-center items-center self-stretch py-2 px-4 pt-3 rounded border-solid',
                        ]">
                        <p class="font-Open">
                            {{ formatDate(key, true) }}
                        </p>
                        <p
                            v-if="item.length"
                            :class="[
                                { 'font-bold': currentlySelected === key },
                                numberClass(item.length),
                            ]">
                            {{
                                `${item.length} space${
                                    item.length > 1 ? 's' : ''
                                } available`
                            }}
                        </p>
                    </div>
                </li>
            </ul>
            <div
                class="show-more cursor-pointer flex flex-col items-center mt-4"
                @click="toggleShowMore"
                v-if="Object.keys(items).length > 7">
                <span
                    class="text-link text-[#5856d6] text-center font-Open text-sm font-light leading-5 underline"
                    >{{ showMore.text }}</span
                >
            </div>
        </div>
        <div v-else>
            <h1 class="text-center font-bold size-xxl">No dates available</h1>
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue';
    import { useBookingStore } from '@/stores/booking';
    import { formatDate } from '@/helpers/dateFormats';
    import { useStatusStore } from '@/stores/status';
    const statusStore = useStatusStore();

    const bookingStore = useBookingStore();
    const currentlySelected = ref(null);

    const showMore = ref({
        enabled: false,
        text: 'See more availability',
    });

    const props = defineProps({
        items: Object,
        title: String,
        selectedStoreOptionA: String,
        selectedStoreOptionB: String,
    });

    const numberClass = (num) => {
        if (!isNaN(num)) {
            return num < 3 ? 'high' : 'low';
        }
    };

    const selectItem = (key) => {
        bookingStore.updateBookingState({
            [props.selectedStoreOptionA]: key,
        });
        currentlySelected.value = key;
    };

    const toggleShowMore = () => {
        showMore.value.enabled = !showMore.value.enabled;
        // Fixed the logic here
        showMore.value.text = showMore.value.enabled
            ? 'Show less'
            : 'See more availability';
    };
</script>

<!-- not scoped due to use using v-html for the subtitle -->
<style lang="scss" scoped>
    .show-limited {
        li:nth-child(1n + 8) {
            display: none;
        }
    }

    .high {
        color: var(--text-text-primary, #e40032);
    }

    .low {
        color: var(--text-text-success-strong, #00851d);
    }
</style>
